import { FormValidationRuleWithState } from "../types";

const isFileUploading: FormValidationRuleWithState = (c, v, s) => {

    let valid = true;
    if (c.type === "fileupload" && c.name && s && s.values) {
        if (s.values[`${c.name}_file_uploading`]) {
            valid = false;
        }
    }
    return [valid, ""];
};

export default isFileUploading;